import { defineComponent as _defineComponent } from 'vue'
import { OnboardingStatus } from '@/enums/onboarding-status';

import GlobalHome from '@/pages/home/GlobalHome.vue';
import OnboardedHome from '@/pages/home/OnboardedHome.vue';

import { useUserStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const UnsupportedCountry = () => import('@/pages/home/UnsupportedCountry.vue');

const { onboardingStatus } = useUserStore();

return { __sfc: true,UnsupportedCountry, onboardingStatus, OnboardingStatus, GlobalHome, OnboardedHome }
}

})